module.exports = __webpack_public_path__ + "img/Solar-Space_symbol_5.c99e5422.png";